(() => {
  /* ==========================================
     RAVYURA AUTO FREE GIFT
     ========================================== */

  // IMPORTANT: REPLACE THESE TWO VALUES
  const FOUNTAIN_PRODUCT_ID = 9332503249058;
  const FREE_GIFT_VARIANT_ID = 47663292055714;

  const GIFT_PROPERTY = '_ravyura_free_gift';
  const GIFT_VALUE = '1';

  let syncing = false;
  let timer = null;

  const nativeFetch = window.fetch.bind(window);

  function rootUrl(path) {
    const root = window.Shopify?.routes?.root || '/';
    return root + path.replace(/^\//, '');
  }

  async function getCart() {
    const response = await nativeFetch(rootUrl('cart.js'), {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to read Shopify cart');
    }

    return response.json();
  }

  function fountainExists(cart) {
    return cart.items.some(item =>
      Number(item.product_id) === Number(FOUNTAIN_PRODUCT_ID)
    );
  }

  function getGiftLines(cart) {
    return cart.items.filter(item =>
      Number(item.variant_id) === Number(FREE_GIFT_VARIANT_ID) &&
      item.properties &&
      item.properties[GIFT_PROPERTY] === GIFT_VALUE
    );
  }

  async function addGift() {
    console.log('Ravyura: adding free gift...');

    const response = await nativeFetch(rootUrl('cart/add.js'), {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        items: [
          {
            id: Number(FREE_GIFT_VARIANT_ID),
            quantity: 1,
            properties: {
              [GIFT_PROPERTY]: GIFT_VALUE
            }
          }
        ]
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Ravyura gift add failed:', data);
      throw new Error(data.description || 'Gift could not be added');
    }

    console.log('Ravyura: gift added successfully', data);
  }

  async function removeGift(key) {
    await nativeFetch(rootUrl('cart/change.js'), {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });
  }

  async function forceGiftQuantityOne(key) {o
    await nativeFetch(rootUrl('cart/change.js'), {
      method: 'POST',

      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },

      body: JSON.stringify({
        id: key,
        quantity: 1
      })
    });
  }

  async function refreshDrawer() {
    try {
      const url =
        `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`;

      const response = await nativeFetch(url);

      const sections = await response.json();

      /* Cart drawer */
      if (sections['cart-drawer']) {
        const parser = new DOMParser();

        const newDocument = parser.parseFromString(
          sections['cart-drawer'],
          'text/html'
        );

        const newDrawer =
          newDocument.querySelector('cart-drawer');

        const currentDrawer =
          document.querySelector('cart-drawer');

        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;

          currentDrawer.classList.remove('is-empty');
          currentDrawer.classList.add('active');
        }
      }

      /* Cart bubble */
      if (sections['cart-icon-bubble']) {
        const currentBubble =
          document.querySelector(
            '#shopify-section-cart-icon-bubble'
          );

        if (currentBubble) {
          currentBubble.innerHTML =
            sections['cart-icon-bubble'];
        }
      }

    } catch (error) {
      console.error(
        'Ravyura drawer refresh error:',
        error
      );
    }
  }

  async function syncGift() {
    if (syncing) return;

    syncing = true;

    try {
      let cart = await getCart();

      const hasFountain = fountainExists(cart);
      let giftLines = getGiftLines(cart);

      console.log(
        'Ravyura Gift Check:',
        {
          hasFountain,
          giftLines,
          cartItems: cart.items
        }
      );

      /* --------------------------
         ADD GIFT
      -------------------------- */

      if (hasFountain && giftLines.length === 0) {

        await addGift();

        // Verify Shopify actually accepted it
        cart = await getCart();

        giftLines = getGiftLines(cart);

        if (giftLines.length) {
          await refreshDrawer();
        } else {
          console.error(
            'Ravyura: Shopify did not retain the gift.'
          );
        }

        return;
      }

      /* --------------------------
         REMOVE GIFT IF FOUNTAIN
         IS REMOVED
      -------------------------- */

      if (!hasFountain && giftLines.length) {

        for (const gift of giftLines) {
          await removeGift(gift.key);
        }

        await refreshDrawer();

        return;
      }

      /* --------------------------
         KEEP GIFT QTY AT 1
      -------------------------- */

      if (
        hasFountain &&
        giftLines.length === 1 &&
        giftLines[0].quantity !== 1
      ) {
        await forceGiftQuantityOne(
          giftLines[0].key
        );

        await refreshDrawer();
      }

    } catch (error) {
      console.error(
        'Ravyura free gift sync error:',
        error
      );
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    clearTimeout(timer);

    timer = setTimeout(
      syncGift,
      350
    );
  }

  /* ==========================================
     WATCH SHOPIFY CART REQUESTS
  ========================================== */

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);

    try {
      const request = args[0];

      const url =
        typeof request === 'string'
          ? request
          : request?.url || '';

      if (
        !syncing &&
        (
          url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        )
      ) {
        scheduleSync();
      }

    } catch (error) {
      console.error(error);
    }

    return response;
  };

  /* ==========================================
     INITIAL CHECK
  ========================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => {
        setTimeout(syncGift, 500);
      }
    );

  } else {

    setTimeout(syncGift, 500);

  }

})();